import { render, staticRenderFns } from "./CodPerformance.vue?vue&type=template&id=4887f792&scoped=true"
import script from "./CodPerformance.vue?vue&type=script&lang=js"
export * from "./CodPerformance.vue?vue&type=script&lang=js"
import style0 from "./CodPerformance.vue?vue&type=style&index=0&id=4887f792&prod&lang=scss&scoped=true"
import style1 from "./CodPerformance.vue?vue&type=style&index=1&id=4887f792&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4887f792",
  null
  
)

export default component.exports